import axios from "axios";
import { parErr } from "@/lib/partnerApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/sch`;
const cfg = (params) => ({ headers: { Authorization: `Bearer ${localStorage.getItem("nex_token")}` }, params });

export const schApi = {
  get: (path, params) => axios.get(`${BASE}${path}`, cfg(params)).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, cfg()).then((r) => r.data),
  put: (path, body) => axios.put(`${BASE}${path}`, body, cfg()).then((r) => r.data),
  patch: (path, body) => axios.patch(`${BASE}${path}`, body, cfg()).then((r) => r.data),
  del: (path) => axios.delete(`${BASE}${path}`, cfg()).then((r) => r.data),
};
export const schErr = parErr;

const KEY = (k) => `tea_sch_${k}`;
export const schPref = {
  get: (k, fallback) => { try { const v = localStorage.getItem(KEY(k)); return v == null ? fallback : JSON.parse(v); } catch { return fallback; } },
  set: (k, v) => localStorage.setItem(KEY(k), JSON.stringify(v)),
};

export const CAT_COLOR = {
  mandatory_individual: "#f43f5e",
  mandatory_group: "#f59e0b",
  work: "#38bdf8",
  pillar: "#10b981",
  public_partner: "#e879f9",
};
export const colorOf = (ev) => CAT_COLOR[ev.category] || "#94a3b8";
export const isAdminUser = (u) => ["super_admin", "admin"].includes(u?.role);
export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const fmtTime = (iso) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
export const fmtDateTime = (iso) => new Date(iso).toLocaleString([], { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
export const toLocalInput = (iso) => {
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
export const fromLocalInput = (v) => new Date(v).toISOString();

const raw = (headers, params) => ({
  get: (path, p) => axios.get(`${BASE}${path}`, { headers: headers(), params: { ...params, ...p } }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: headers(), params }).then((r) => r.data),
});
export const residentSchApi = (token) => raw(() => ({}), { token });
export const partnerSchApi = raw(() => ({ Authorization: `Bearer ${localStorage.getItem("tea_partner_token")}` }));
export const publicSchApi = raw(() => ({}));
export const fmtDay = (iso) => new Date(iso).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
